export enum Role {
  Admin = 'admin',
  CorporateAdmin = 'corporate_admin_member',
  RealEstateBroker = 'real_estate_broker_member',
  RegularSyndicateAdmin = 'regular_syndicate_admin_member',
  RegularSyndicateManager = 'regular_syndicate_manager_member',
  RegularSyndicateCoOwner = 'regular_syndicate_coowner_member',
  RegularIndividual = 'regular_individual_member'
}